"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnySentenceWithSentenceWordFlashcard = exports.isAnySentenceFlashcard = exports.AnySentenceFlashcardSchema = exports.isAnyNonBootcampSentenceFlashcard = exports.AnyNonBootcampSentenceFlashcardSchema = exports.isAnyBootcampSentenceFlashcard = exports.AnyBootcampSentenceFlashcardSchema = exports.isWordOrderFlashcard = exports.isFillInTheBlankRootFlashcard = exports.isFillInTheBlankFlashcard = exports.isBootcampWordToSentenceFlashcard = exports.BootcampWordToSentenceFlashcardSchema = exports.isBootcampWordOrderFlashcard = exports.isBootcampFillInTheBlankFlashcard = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const image_association_types_1 = require("../image_association_types");
const sentence_word_types_1 = require("../sentence/sentence_word_types");
const flashcard_back_types_1 = require("./flashcard_back_types");
const flashcard_common_types_1 = require("./flashcard_common_types");
const sentence_flashcard_type_types_1 = require("./sentence_flashcard_type_types");
const BaseSentenceFlashcardSchema = flashcard_common_types_1.FlashcardBaseSchema.extend({
    sentence_id: zod_1.z.string(),
    sentence_word: sentence_word_types_1.SentenceWordSchema,
    tag_ids: zod_1.z.string().array(),
});
const BootcampFillInTheBlankFlashcardSchema = BaseSentenceFlashcardSchema.extend({
    type: sentence_flashcard_type_types_1.BootcampFillInTheBlankFlashcardTypeSchema,
});
exports.isBootcampFillInTheBlankFlashcard = type_validation_helpers_1.getTypeValidationFunction(BootcampFillInTheBlankFlashcardSchema);
const BootcampWordOrderFlashcardSchema = BaseSentenceFlashcardSchema.extend({
    type: sentence_flashcard_type_types_1.BootcampWordOrderFlashcardTypeSchema,
});
exports.isBootcampWordOrderFlashcard = type_validation_helpers_1.getTypeValidationFunction(BootcampWordOrderFlashcardSchema);
// Not using BaseSentenceFlashcardSchema - this is intentional
exports.BootcampWordToSentenceFlashcardSchema = flashcard_common_types_1.FlashcardBaseSchema.extend({
    backs: flashcard_back_types_1.AnySentenceFlashcardBackSchema.array(),
    images: image_association_types_1.ImageSchema.array(),
    sentence_id: zod_1.z.string(),
    type: sentence_flashcard_type_types_1.BootcampWordToSentenceFlashcardTypeSchema,
    word_audio_url: zod_1.z.string().optional(),
    word_known_txt: zod_1.z.string().optional(),
    word_learn_id: zod_1.z.string(),
    word_learn_txt: zod_1.z.string(),
});
exports.isBootcampWordToSentenceFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.BootcampWordToSentenceFlashcardSchema);
const FillInTheBlankFlashcardSchema = BaseSentenceFlashcardSchema.extend({
    type: sentence_flashcard_type_types_1.FillInTheBlankFlashcardTypeSchema,
});
exports.isFillInTheBlankFlashcard = type_validation_helpers_1.getTypeValidationFunction(FillInTheBlankFlashcardSchema);
const FillInTheBlankRootFlashcardSchema = BaseSentenceFlashcardSchema.extend({
    type: sentence_flashcard_type_types_1.FillInTheBlankRootFlashcardTypeSchema,
});
exports.isFillInTheBlankRootFlashcard = type_validation_helpers_1.getTypeValidationFunction(FillInTheBlankRootFlashcardSchema);
const WordOrderFlashcardSchema = BaseSentenceFlashcardSchema.extend({
    type: sentence_flashcard_type_types_1.WordOrderFlashcardTypeSchema,
});
exports.isWordOrderFlashcard = type_validation_helpers_1.getTypeValidationFunction(WordOrderFlashcardSchema);
exports.AnyBootcampSentenceFlashcardSchema = zod_1.z.union([
    BootcampFillInTheBlankFlashcardSchema,
    BootcampWordOrderFlashcardSchema,
    exports.BootcampWordToSentenceFlashcardSchema,
]);
exports.isAnyBootcampSentenceFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.AnyBootcampSentenceFlashcardSchema);
exports.AnyNonBootcampSentenceFlashcardSchema = zod_1.z.union([
    FillInTheBlankFlashcardSchema,
    FillInTheBlankRootFlashcardSchema,
    WordOrderFlashcardSchema,
]);
exports.isAnyNonBootcampSentenceFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.AnyNonBootcampSentenceFlashcardSchema);
exports.AnySentenceFlashcardSchema = zod_1.z.union([
    exports.AnyBootcampSentenceFlashcardSchema,
    exports.AnyNonBootcampSentenceFlashcardSchema,
]);
exports.isAnySentenceFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.AnySentenceFlashcardSchema);
const AnySentenceWithSentenceWordFlashcardSchema = zod_1.z.union([
    exports.AnyNonBootcampSentenceFlashcardSchema,
    BootcampFillInTheBlankFlashcardSchema,
    BootcampWordOrderFlashcardSchema,
]);
exports.isAnySentenceWithSentenceWordFlashcard = type_validation_helpers_1.getTypeValidationFunction(AnySentenceWithSentenceWordFlashcardSchema);
//# sourceMappingURL=sentence_flashcard_types.js.map